module.exports = __webpack_public_path__ + "static/media/preview_content_purchases.4ebf93b6.PNG";